// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"573f1ce0","425":"b0dc670a","473":"e27b6018","489":"697acd5a","741":"5aef001a","774":"229c9368","883":"37842035"}[chunkId] + ".chunk.js";
};